import React, {useRef} from 'react'
import Guacamole from "guacamole-common-js";
import {useToasts} from "react-toast-notifications";

const FileUpload = (props) => {
    const {addToast} = useToasts()
    const inputFile = useRef(null);

    const fileUploadNotification = (content) => {
        addToast(content, {
            appearance: 'info',
            autoDismiss: true,
        })
    }

    const handleFileUpload = (event) => {
        const uploads = event.target.files
        for (const file of uploads) {
            fileUploadNotification(`Uploading File ${file.name}`)
            let reader = new FileReader();
            reader.onloadend = function fileContentsLoaded(e) {
                // Create a file stream with the file's mimetype and name
                const stream = props.client.createFileStream(file.type, file.name);

                // Create an ArrayBufferWriter for the stream
                let bufferWriter = new Guacamole.ArrayBufferWriter(stream);

                // Send the ArrayBuffer data
                bufferWriter.sendData(reader.result);

                // Signal the end of the stream
                bufferWriter.sendEnd();

                props.onFileUploadNotification(`Successfully Uploaded File ${file.name}`, "success")
            };
            reader.readAsArrayBuffer(file);
        }
    };

    const onButtonClick = () => {
        inputFile.current.click();
    };

    return (
        <>
            <button id={"customFile"}
                    onClick={onButtonClick}
                    type="button"
                    className="btn">Upload</button>
            <input
                style={{ display: "none" }}
                ref={inputFile}
                onChange={handleFileUpload}
                multiple
                type="file"
            />
        </>
    )
}
export default React.memo(FileUpload)
